import { render, staticRenderFns } from "./EcommerceFilesTable.vue?vue&type=template&id=aaa4cd7e&scoped=true&"
import script from "./EcommerceFilesTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceFilesTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceFilesTable.vue?vue&type=style&index=0&id=aaa4cd7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa4cd7e",
  null
  
)

export default component.exports